// Константы стилей Excel
export const EXCEL_STYLES = {
  HEADER_BG: 'FFdafff0',
  HEADER_BORDER: 'FFC1E3D5',
  TITLE_BAR_BG: 'FF1a7367',
  SUBHEADER_BG: 'FF4CAF50',
  GRID_BORDER: 'FFD0D0D0',
  FOOTER_TEXT: 'FF888888',
  WHITE_TEXT: 'FFFFFFFF',
  BLACK_TEXT: 'FF222222',
  MILESTONE_BG: 'FFE91E63',
  TASK_BG: 'FF03A9F4',
  AGGREGATION_BG: 'FFFFFFFF',
  GROUP_AGGREGATION_BG: 'FFE8F5E8',
  PARENT_AGGREGATION_BG: 'FFE3F2FD',
  LEVEL_TEXT: "FF808080",
};

export const EXCEL_CONSTANTS = {
  nameTaskColumnKey: "name",
}

export const DEFAULT_LOGO = '';

export const DATA_FORMATS = {
  WBS: 'wbs',
  FLAT: 'flat',
  GROUPED: 'grouped',
  NESTED_GROUP: 'nested-group'
};